import { useEffect, RefObject } from 'react';
import { useScreenSize } from '@ds/utils/hooks/useScreenSize';

/**
 * Custom hook to handle smart scrolling of a container element. Smark scolling is only applied on desktop devices.
 * @param containerRef - Ref to the scrollable container.
 */
const useSmartScroll = (containerRef: RefObject<HTMLDivElement | null>) => {
  const { isDesktop } = useScreenSize();

  useEffect(() => {
    if (!isDesktop) {
      if (containerRef.current) {
        containerRef.current.style.top = '';
      }
      return;
    }

    const header = document.querySelector('#header') as HTMLElement;
    if (!header) return;

    const headerHeight = header.offsetHeight;
    const element = containerRef.current;
    if (!element) return;

    let animationFrameId: number;

    const handleScroll = () => {
      animationFrameId = requestAnimationFrame(() => {
        if (!containerRef.current) return;

        const { bottom, top } = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (windowHeight > element.clientHeight) {
          element.style.top = `${headerHeight}px`;
        } else if (bottom <= windowHeight) {
          element.style.top = `-${element.clientHeight - windowHeight}px`;
        } else if (top > headerHeight) {
          element.style.top = '';
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(animationFrameId);
    };
  }, [containerRef, isDesktop]);
};

export default useSmartScroll;
